<template>
  <fieldset class="radio-group-fieldset">
    <legend v-if="label || field?.label" class="radio-group-legend visually-hidden">{{ label || field?.label }}</legend>
    <div class="text-center" role="presentation">
      <div class="btn-group text-center" data-toggle="buttons" role="presentation">
        <div v-for="(option,idx) in options" :key="idx">
          <input type="radio" class="btn-check" :name="name" autocomplete="off" :value="option.val" v-model="selected" :id="`item_`+name+`_`+idx" :aria-required="fieldAriaRequired" :aria-describedby="fieldDescribedBy" :aria-invalid="fieldAriaInvalid" @change="$emit('change')">
          <label class="btn btn1 text-center" :for="`item_`+name+`_`+idx">
            {{ option.text }}
          </label>
        </div>
      </div>
    </div>
    <div class="invalid-feedback" :id="`${name}invalid`">{{field?.error_message}}</div>
  </fieldset>
</template>
<script>
import formFieldA11y from '@/mixins/formFieldA11y.js'

export default {
  mixins: [formFieldA11y],
  props: {
    label: String,
    type: String,
    name: String,
    value: [Number, String],
    options: Array,
    field: Object,
  },
  data() {
    return {
      selected: this.value != null && this.value !== '' ? this.value : null,
    }
  },
  watch: {
    value(next) {
      this.selected = next != null && next !== '' ? next : null;
    }
  }
}
</script>
<style scoped>
.radio-group-fieldset {
  border: none;
  margin: 0;
  padding: 0;
  min-width: 0;
}

.radio-group-legend {
  border: none;
  padding: 0;
  margin: 0;
  font: inherit;
  float: none;
  width: auto;
}

.btn1 {
  border: 1px solid #bbbaba;
  border-radius: 20px;
  background: white;
  margin: 0 5px;
  display: inline-block;
  text-align: center;
  color: #171717;
  text-decoration: none;
}

.btn-check:checked + .btn1 {
  color: #EF3D49;
  border-color: #EF3D49;
}
</style>
